import { DistributionReportStat } from '../../../../../../Common/TargetingShared/model/statisticsReport/distribution-report-stat-api.model';
import { TargetingQueryApi } from '../../../../../../api/targeting/model/targeting-search.api.model';

export class RecipientSearchModel {
    link?: string;
    statType?: DistributionReportStat;
    listId?: number;
    searchId?: number;
    query: TargetingQueryApi;
}
